<template>
  <div class="col-12 p-0">
    <div class="position-relative custom__progress">
      <CProgress class="mb-3">
        <CProgressBar color="success" :value="progress" />
      </CProgress>

      <div
        class="d-flex justify-content-between step__dots-container col-12 p-0"
      >
        <div
          class="step__dot shadow-sm"
          v-for="(step, s) in steps"
          :key="s"
          @click="handleModal(s)"
        >
          <small>{{ step }}</small>
        </div>
      </div>
    </div>

    <CModal :show.sync="modals.datos">
      <template #header-wrapper>
        <div class="card-header">
          <h5 class="mb-0">Datos generales</h5>
        </div>
      </template>
      <template #footer-wrapper><span></span></template>
      <div class="card-body p-0 d-flex flex-wrap">
        <div class="alert alert-danger w-100 text-center" v-if="!payload.datos">
          Aún no hay datos seleccionados
        </div>
        <div v-else>
          <h5 class="text-dark pb-2"><i class="fal fa-car"></i> Auto</h5>
          <div class="d-flex flex-wrap align-items-center">
            <div class="col-6">
              <p><b>Marca:</b> {{ payload.datos.marca }}</p>
            </div>
            <div class="col-6">
              <p><b>Modelo:</b> {{ payload.datos.modelo }}</p>
            </div>
            <div class="col-6">
              <p><b>Submarca:</b> {{ payload.datos.submarca }}</p>
            </div>
            <div class="col-6">
              <p><b>Kilometros:</b> {{ payload.datos.km }}</p>
            </div>
            <div class="col-6">
              <p><b>CP circulación:</b> {{ payload.datos.cp }}</p>
            </div>

            <h5 class="w-100 text-dark pt-2 pb-2">
              <i class="far fa-user"></i> Personales
            </h5>

            <div class="col-12">
              <p><b>Nombre:</b> {{ payload.datos.fullname }}</p>
            </div>
            <div class="col-12">
              <p><b>Correo:</b> {{ payload.datos.email }}</p>
            </div>
            <div class="col-6">
              <p><b>Fecha nac.:</b> {{ payload.datos.fecha_nac }}</p>
            </div>
            <div class="col-6">
              <p><b>Teléfono:</b> {{ payload.datos.phone }}</p>
            </div>
            <div class="col-6">
              <p><b>Sexo:</b> {{ payload.datos.sexo }}</p>
            </div>

            <h5 class="w-100 text-dark pt-2 pb-2">
              <i class="far fa-user"></i> Póliza
            </h5>
            <div class="col-6">
              <p>
                <b>Periodo de vigencia:</b> {{ payload.datos.tipoVigencia }}
              </p>
            </div>
            <div class="col-6">
              <p><b>Vigencia desde:</b> {{ payload.datos.vig_ini }}</p>
            </div>
            <div class="col-6">
              <p><b>Vigencia hasta:</b> {{ payload.datos.vig_fin }}</p>
            </div>
          </div>
        </div>
      </div>

      <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
        <CButton @click="modals.datos = false" color="outline-secondary">
          Cerrar
        </CButton>
      </CCardFooter>
    </CModal>

    <CModal :show.sync="modals.coberturas" size="lg">
      <template #header-wrapper>
        <div class="card-header">
          <h5 class="mb-0">Coberturas</h5>
        </div>
      </template>
      <template #footer-wrapper><span></span></template>
      <div class="card-body p-0">
        <div class="alert alert-danger w-100 text-center" v-if="!payload.basicas">
          Sin coberturas añadidas
        </div>
        <div class="col-12" v-else>
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th>Nombre</th>
                <th>Suma asegurada</th>
                <th>Deducible</th>
                <th>Costo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cob, c) in payload.basicas" :key="c">
                <td>{{cob.name}}</td>
                <td>${{ formatMoney(cob.sa) }}</td>
                <td>{{ cob.deducible }}</td>
                <td>${{ formatMoney(cob.costo) }}</td>
              </tr>
            </tbody>
          </table>
        
        </div>
      </div>

      <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
        <CButton @click="modals.coberturas = false" color="outline-secondary">
          Cerrar
        </CButton>
      </CCardFooter>
    </CModal>

    <CModal :show.sync="modals.cotizacion">
      <template #footer-wrapper><span></span></template>
      <div class="card-body p-0 d-flex flex-wrap"></div>

      <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
        <CButton @click="modals.cotizacion = false" color="outline-secondary">
          Cerrar
        </CButton>
      </CCardFooter>
    </CModal>
  </div>
</template>

<script>
import { format } from '../../../assets/helpers'
export default {
  data() {
    return {
      current: 0,
      progress: 0,
      modals: {
        datos: false,
        coberturas: false,
        cotizacion: false,
      },
    };
  },
  props: {
    steps: Array,
    currentStep: Number,
    payload: null,
  },
  methods: {
    next() {
      const totalDots = this.steps.length;
      if (totalDots == 0 || this.current == totalDots - 1) {
        return;
      }

      this.current++;
      this.progress = (100 / (totalDots - 1)) * this.current;
    },
    handleModal(step) {
      console.log(step, this.currentStep - 1);
      if (this.currentStep - 1 < step) {
        return;
      }

      switch (step) {
        case 0:
          this.modals.datos = true;
          break;

        case 1:
          this.modals.coberturas = true;
          break;

        case 2:
          this.modals.cotizacion = true;
          break;

        default:
          break;
      }
    },
    formatMoney(amount) {
      return format.money(amount)
    },
    prev() {
      const totalDots = this.steps.length;
      const progres = this.progress - 100 / (totalDots - 1);

      this.progress = progres > 0 ? progres : 0;
      if (this.current == 0) {
        return;
      }
      this.current--;
    },
  },
};
</script>

<style lang="scss">
.custom__progress .progress {
  background-color: #cdd2d8;
  border-radius: 20px;
  height: 10px;
}
.step__dots-container {
  position: absolute;
  top: -5px;
  left: 0;
}
.step__dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  position: relative;

  small {
    width: 80px;
    text-align: center;
    position: absolute;
    bottom: 20px;
    left: -40px;
    color: #9b9b9b;
  }

  &:last-child small {
    text-align: right;
    left: -50px;
  }
  &:first-child small {
    text-align: left;
    left: 0;
  }
  &:hover {
    cursor: pointer;
  }
}

@media only screen and (min-width: 640px) {
  .step__dot {
    small {
      width: 100px;
    }
    &:last-child small {
      text-align: right;
      left: -90px;
    }
  }
}
</style>